import { FC, useEffect, useState } from "react";
import styles from "./SortArrow.module.scss";
import ArrowIcon from "./assets/sortArrowIcon.svg";
import SortIcon from "@/shared/assets/sortVertical.svg";

interface SortArrowProps {
  sortFunction: (value: SortType) => void;
  name: string | null;
  selectedName?: string;
  selectedType?: "asc" | "desc";
  dataTestId?: string;
}

export type SortType = {
  name: string;
  type: "asc" | "desc" | "none";
};

export const SortArrow: FC<SortArrowProps> = ({
  sortFunction,
  name,
  selectedName = "",
  selectedType,
  dataTestId,
}) => {
  const [sortType, setSortType] = useState<"asc" | "desc" | "none">("none");

  const handleClick = () => {
    if (sortType === "none") {
      sortFunction({ name: name, type: "desc" });
      setSortType("desc");
      return;
    }
    if (sortType === "desc") {
      sortFunction({ name: name, type: "asc" });
      setSortType("asc");
      return;
    }
    if (sortType === "asc") {
      sortFunction({ name: name, type: "desc" });
      setSortType("desc");
      return;
    }
  };
  useEffect(() => {
    if (name !== selectedName) {
      setSortType("none");
    } else {
      setSortType(selectedType);
    }
  }, [name, selectedName, selectedType]);
  return (
    <span
      className={`${styles.sortWrapper} ${styles[sortType]}`}
      onClick={handleClick}
      id={sortType}
      {...(dataTestId ? { "data-testid": dataTestId } : {})}
    >
      {sortType === "none" ? <SortIcon /> : <ArrowIcon />}
    </span>
  );
};
